import Header from "../../../components/Partials/Header/Header";
import s from './dashboard.module.scss'
import React, {useEffect, useRef, useState} from "react";
import SvgSelector from "../../../components/SvgSelector/SvgSelector";
import BarCharts from "./TopContainer/BarCharts/BarCharts";
import {MuiDatePicker} from "../../../components/DatePickers/MuiDatePicker";
import {stringToDayJs} from "../../../utils/helpers/formatTime";
import {useTranslation} from "react-i18next";
import AppsStatistics from "./TopContainer/AppsStatistics/AppsStatistics";
import GeoStatistics from "./BottomContainer/GeoStatistics/GeoStatistics";
import CirclePieChart from "./BottomContainer/PieChart/PieChart";
import ClientsStatistics from "./BottomContainer/ClientsStatistics/ClientsStatistics";
import CategoriesStatistics from "./BottomContainer/CategoriesStatistics/CategoriesStatistics";
import {fetchTopApps, fetchTopCategories, fetchTopClients, fetchTopGeos} from "../../../redux/slices/dashboardSlice";
import {useDispatch} from "react-redux";
import useGetSearchParams from "../../../hooks/useGetSearchParams";
// import {dashboardParams} from "../../../utils/vars/params";
import useSetSearchParams from "../../../hooks/useSetSearchParams";
import {useSearchParams} from "react-router-dom";
import {
    app_created_at_after,
    app_created_at_before,
    categories_created_at_after,
    categories_created_at_before,
    clients_created_at_after,
    clients_created_at_before,
    geo_created_at_after,
    geo_created_at_before
} from "../../../utils/vars/dashboardParams";
import NewBarCharts from "./TopContainer/NewBarCharts/NewBarCharts";


// export const {app_created_at_after, app_created_at_before} = dashboardParams

const Dashboard = () => {

    const {t} = useTranslation();

    const dispatch = useDispatch();

    const [searchParams, setSearchParams] = useSearchParams();

    const updateSearchParams = useSetSearchParams(setSearchParams);


    const {
        app_created_at_after: app_created_at_after_param,
        app_created_at_before: app_created_at_before_param,
        geo_created_at_before: geo_created_at_before_param,
        geo_created_at_after: geo_created_at_after_param,
        clients_created_at_after: clients_created_at_after_param,
        clients_created_at_before: clients_created_at_before_param,
        categories_created_at_after: categories_created_at_after_param,
        categories_created_at_before: categories_created_at_before_param,
    } = useGetSearchParams();


    useEffect(() => {
        dispatch(fetchTopApps(searchParams))
    }, [dispatch, app_created_at_after_param, app_created_at_before_param])

    useEffect(() => {
        dispatch(fetchTopGeos(searchParams))
    }, [dispatch, geo_created_at_before_param, geo_created_at_after_param])

    useEffect(() => {
        dispatch(fetchTopClients(searchParams))
    }, [dispatch, clients_created_at_after_param, clients_created_at_before_param])

    useEffect(() => {
        dispatch(fetchTopCategories(searchParams))
    }, [dispatch, categories_created_at_after_param, categories_created_at_before_param])

    return (
        <div className={s.dashboardPageContainer}>
            <Header/>
            <div className={s.pageContent}>
                <div className={s.chartsStatisticsContainer}>
                    <div className={s.header}>
                        <div className={s.titleContainer}>
                            <SvgSelector id="app-select-icon"/>
                            <p className={s.title}>{t('applications')}</p>
                        </div>
                        <div className={s.datePickersWrapper}>
                            <div className={s.datePicker}>
                                <MuiDatePicker
                                    label={t("date_from")}
                                    searchParamValue={app_created_at_after}
                                />
                            </div>
                            <div className={s.datePicker}>
                                <MuiDatePicker
                                    label={t("date_to")}
                                    searchParamValue={app_created_at_before}
                                />
                            </div>
                        </div>
                    </div>
                    <div className={s.body}>
                        <div className={s.barChartsTableScrollContainer}>
                            <div className={s.barChartsWrapper}>
                                <NewBarCharts/>
                            </div>
                            <div className={s.appsStatisticsWrapper}>
                                <AppsStatistics/>
                            </div>
                        </div>
                    </div>
                </div>
                <div className={s.bottomTablesContainer}>
                    <div className={s.pieChartTableContainer}>
                        <div className={s.header}>
                            <div className={s.titleContainer}>
                                <SvgSelector id="domain-select-icon"/>
                                <p className={s.title}>{t('geo')}</p>
                            </div>
                            <div className={s.datePickersWrapper}>
                                <div className={s.datePicker}>
                                    <MuiDatePicker
                                        label={t("date_from")}
                                        searchParamValue={geo_created_at_after}
                                    />
                                </div>
                                <div className={s.datePicker}>
                                    <MuiDatePicker
                                        label={t("date_to")}
                                        searchParamValue={geo_created_at_before}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className={s.body}>
                            <div className={s.pieChartsTableWrapper}>
                                <GeoStatistics/>
                                <div className={s.pieChartWrapper}>
                                    <p className={s.pieChartTitle}>
                                        {t('geo_chart')}
                                    </p>
                                    <CirclePieChart/>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className={s.clientsCategoryTablesWrapper}>
                        <div className={s.clientsTableWrapper}>
                        <div className={s.header}>
                            <div className={s.titleContainer}>
                                <SvgSelector id="dashboard-clients-icon"/>
                                <p className={s.title}>{t('clients')}</p>
                            </div>
                            <div className={s.datePickersWrapper}>
                                <div className={s.datePicker}>
                                    <MuiDatePicker
                                        label={t("date_from")}
                                        searchParamValue={clients_created_at_after}
                                    />
                                </div>
                                <div className={s.datePicker}>
                                    <MuiDatePicker
                                        label={t("date_to")}
                                        searchParamValue={clients_created_at_before}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className={s.body}>
                            <ClientsStatistics/>
                        </div>
                    </div>
                        <div className={s.categoryTableWrapper}>
                        <div className={s.header}>
                            <div className={s.titleContainer}>
                                <SvgSelector id="dashboard-categories-icon"/>
                                <p className={s.title}>{t('categories')}</p>
                            </div>
                            <div className={s.datePickersWrapper}>
                                <div className={s.datePicker}>
                                    <MuiDatePicker
                                        label={t("date_from")}
                                        searchParamValue={categories_created_at_after}
                                    />
                                </div>
                                <div className={s.datePicker}>
                                    <MuiDatePicker
                                        label={t("date_to")}
                                        searchParamValue={categories_created_at_before}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className={s.body}>
                            <CategoriesStatistics/>
                        </div>
                    </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Dashboard;